import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9 2.25c2.535 0 4.754 1.224 6.64 3.237.65.692 1.212 1.43 1.69 2.169.288.446.485.798.59 1.009.106.21.106.46 0 .67-.105.211-.302.563-.59 1.01-.478.738-1.04 1.476-1.69 2.168-1.886 2.013-4.105 3.237-6.64 3.237-2.535 0-4.754-1.224-6.64-3.237-.65-.692-1.212-1.43-1.69-2.169-.288-.446-.485-.798-.59-1.009-.106-.21-.106-.46 0-.67.105-.211.302-.563.59-1.01.478-.738 1.04-1.476 1.69-2.168C4.245 3.474 6.464 2.25 9 2.25zm0 1.5c-2.059 0-3.918 1.026-5.547 2.763-.582.621-1.091 1.289-1.522 1.956-.123.19-.231.368-.325.531.094.163.202.341.325.53.43.668.94 1.336 1.522 1.957C5.083 13.224 6.941 14.25 9 14.25c2.059 0 3.918-1.026 5.547-2.763.582-.621 1.091-1.289 1.522-1.956.123-.19.231-.368.325-.531-.094-.163-.202-.341-.325-.53-.43-.668-.94-1.336-1.522-1.957C12.917 4.776 11.059 3.75 9 3.75zM9 6c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0 1.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5S9.828 7.5 9 7.5z"
	})
});
export default SvgEye;
